module.exports = __webpack_public_path__ + "static/neutral01-32a87f9b4e8a25f0a36fa20ff1bc34bb.png";